<template>
  <div class="sidebar-area">
    <div class="logo position-relative">
      <RouterLink
        to="/dashboard"
        class="d-block text-decoration-none position-relative"
      >
       <img src="@/assets/images/logo_half_rc_text.svg" alt="logo-icon" />
      </RouterLink>
      <button
        class="sidebar-burger-menu bg-transparent p-0 border-0 opacity-0 z-n1 position-absolute top-50 end-0 translate-middle-y"
        id="sidebar-burger-menu"
        @click="stateStoreInstance.onChange"
      >
        <i data-feather="x"></i>
      </button>
    </div>

    <div class="layout-menu menu-vertical menu hover-scroll-bar">
      <ul class="menu-inner">
        <li class="menu-title small text-uppercase">
          <span class="menu-title-text">MAIN</span>
        </li>
        <li class="menu-item" :class="{ open: isOpen('dashboard') }">
          <RouterLink to="/dashboard" class="menu-link active">
            <span class="material-symbols-outlined menu-icon">dashboard</span>
            <span class="title">Dashboard</span>
          </RouterLink>
        </li>

        <li class="menu-title small text-uppercase">
          <span class="menu-title-text">MANAGEMENT</span>
        </li>
        <li class="menu-item">
          <RouterLink to="/customers" class="menu-link">
            <span class="material-symbols-outlined menu-icon">group</span>
            <span class="title">Customers</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/services" class="menu-link">
            <span class="material-symbols-outlined menu-icon">build</span>
            <span class="title">Services</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/packages" class="menu-link">
            <span class="material-symbols-outlined menu-icon">inventory_2</span>
            <span class="title">Packages</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/similarity-profiles" class="menu-link">
            <span class="material-symbols-outlined menu-icon">tune</span>
            <span class="title">Similarity Profiles</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/protocol-signatories" class="menu-link">
            <span class="material-symbols-outlined menu-icon">draw</span>
            <span class="title">Penandatangan</span>
          </RouterLink>
        </li>
        <li class="menu-item" v-if="isSuperAdmin">
          <RouterLink to="/users" class="menu-link">
            <span class="material-symbols-outlined menu-icon">manage_accounts</span>
            <span class="title">Users</span>
          </RouterLink>
        </li>
        <li class="menu-item" v-if="isSuperAdmin">
          <RouterLink to="/testimonials" class="menu-link">
            <span class="material-symbols-outlined menu-icon">chat_bubble</span>
            <span class="title">Testimonials</span>
          </RouterLink>
        </li>
        <li class="menu-item" v-if="isSuperAdmin">
          <RouterLink to="/partners" class="menu-link">
            <span class="material-symbols-outlined menu-icon">handshake</span>
            <span class="title">Partners</span>
          </RouterLink>
        </li>
        <li class="menu-item" v-if="isSuperAdmin">
          <RouterLink to="/blog-posts" class="menu-link">
            <span class="material-symbols-outlined menu-icon">rss_feed</span>
            <span class="title">Blogs</span>
          </RouterLink>
        </li>
        <li class="menu-item" v-if="isSuperAdmin">
          <RouterLink to="/translate-price-tiers" class="menu-link">
            <span class="material-symbols-outlined menu-icon">translate</span>
            <span class="title">Translate Pricing</span>
          </RouterLink>
        </li>
        

        <li class="menu-title small text-uppercase">
          <span class="menu-title-text">TRANSACTIONS</span>
        </li>
        <li class="menu-item">
          <RouterLink to="/orders" class="menu-link">
            <span class="material-symbols-outlined menu-icon">shopping_cart</span>
            <span class="title">Orders</span>
          </RouterLink>
        </li>
        <li class="menu-item" v-if="!isQc">
          <RouterLink to="/payments" class="menu-link">
            <span class="material-symbols-outlined menu-icon">payments</span>
            <span class="title">Payments</span>
          </RouterLink>
        </li>
        <li class="menu-item" v-if="!isQc">
          <RouterLink to="/payment-channels" class="menu-link">
            <span class="material-symbols-outlined menu-icon">account_balance</span>
            <span class="title">Payment Channels</span>
          </RouterLink>
        </li>

        <li class="menu-title small text-uppercase">
          <span class="menu-title-text">OTHERS</span>
        </li>
        
        <li class="menu-item">
          <RouterLink to="/authentication/logout" class="menu-link">
            <span class="material-symbols-outlined menu-icon">logout</span>
            <span class="title">Logout</span>
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted } from "vue";
import feather from "feather-icons";
import stateStore from "@/utils/store";

export default defineComponent({
  name: "LeftSidebar",
  setup() {
    const stateStoreInstance = stateStore;

    const isSuperAdmin = computed(() => {
      const userStr = localStorage.getItem('user');
      if (!userStr) return false;
      try {
        const user = JSON.parse(userStr);
        return user.role === 'super_admin';
      } catch (e) {
        return false;
      }
    });

    const isQc = computed(() => {
      const userStr = localStorage.getItem('user');
      if (!userStr) return false;
      try {
        const user = JSON.parse(userStr);
        return user.role === 'qc';
      } catch (e) {
        return false;
      }
    });

    // Reactive state to track which menu items are open
    const openMenu = ref(null);

    // Method to toggle the menu items
    const toggleMenu = (menu) => {
      // If the same menu is clicked, toggle it; otherwise, open the clicked menu
      openMenu.value = openMenu.value === menu ? null : menu;
    };

    // Method to check if a menu is open
    const isOpen = (menu) => {
      return openMenu.value === menu;
    };

    onMounted(() => {
      feather.replace();
    });

    return {
      stateStoreInstance,
      toggleMenu,
      isOpen,
      isSuperAdmin,
      isQc,
    };
  },
});
</script>
